import { gql } from "@apollo/client";

const USER_FIXTURES = gql`
  query userFixtures($where: FixtureWhereInput!) {
    userFixtures(where: $where) {
      id
      createdAt
      scheduledStart
      actualStart
      totalLegs
      legs {
        id
      }
      roles {
        id
        order
        type {
          id
          name
        }
        organization {
          id
          name
          profilePhoto {
            id
            filename
          }
        }
        profile {
          id
          name
          profilePhoto {
            id
            filename
          }
        }
      }
      event {
        id
        sport {
          id
          name
        }
      }
      eventPart {
        id
      }
      placements(where: { type: { name: "RESULT" } }) {
        id
        order
        organization {
          id
        }
        profile {
          id
        }
        value
        valueString
      }
      badmintonBoxScore {
        id
        label
        homeScore
        awayScore
      }
    }
  }
`;

export default USER_FIXTURES;
